import { render, staticRenderFns } from "./OrderFabric.vue?vue&type=template&id=c0fe5f02&scoped=true&"
import script from "./OrderFabric.vue?vue&type=script&lang=js&"
export * from "./OrderFabric.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0fe5f02",
  null
  
)

export default component.exports